import React from 'react';
import bg1 from '/assets/backgrounds/1.png';
import umWhite from '/assets/backgrounds/um_white.png';

type ErrorMessageProps = {
    message: string;
    children?: React.ReactNode;
    style?: React.CSSProperties;
};

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, children, style }) => {
    return (
        <div
            className="auth-error-message-screen"
            style={
                {
                    '--auth-error-message-bg-image': `url(${bg1})`,
                    ...style,
                } as React.CSSProperties
            }
        >
            <div className="auth-error-message-content">
                <img className="auth-error-message-logo" src={umWhite} alt="UrbanMetrix" />
                <div className="auth-error-message-text">{message}</div>
                {children}
            </div>
        </div>
    );
};

export default ErrorMessage;
